import type { NolaPfContestDepartment } from "@/lib/models/nolaPfContest";

/** departmentId または name が空の項目は選択肢にしない。 */
export function visibleContestDepartments(
  departments: NolaPfContestDepartment[] | undefined
): NolaPfContestDepartment[] {
  return (departments ?? []).filter((department) => department.departmentId.length > 0 && department.name.length > 0);
}

export function toContestDepartmentOptions(
  departments: NolaPfContestDepartment[] | undefined
): Array<{ value: string; label: string }> {
  return visibleContestDepartments(departments).map((department) => ({
    value: department.departmentId,
    label: department.name,
  }));
}

export function findContestDepartmentName(
  departments: NolaPfContestDepartment[] | undefined,
  departmentId: string
): string {
  if (!departmentId) return "";
  return visibleContestDepartments(departments).find((department) => department.departmentId === departmentId)?.name ?? "";
}
